import { store as storeNotification } from "react-notifications-component";

const DEFAULT_NOTIFICATION_DURATION_MS = 3000;

/** Longer display for multi-line scan feedback (QR, validity, verify hints). */
export const SCAN_NOTIFICATION_DURATION_MS = 6000;

const showNotification = (
  title: string,
  message: string,
  type: string,
  durationMs: number = DEFAULT_NOTIFICATION_DURATION_MS
) => {
  storeNotification.addNotification({
    //isMobile: true,
    title: title,
    message: message,
    type: type,
    insert: "top",
    container: "bottom-center",
    animationIn: ["animated", "fadeIn"], // animate.css classes that's applied
    animationOut: ["animated", "fadeOut"],
    dismiss: {
      duration: durationMs,
      //showIcon: true
    }
  });
};

export const showSuccessNotification = (message: string) => {
  showNotification("Opération reussie", message, "default");
};

export const showErrorNotification = (
  message: string,
  durationMs: number = DEFAULT_NOTIFICATION_DURATION_MS
) => {
  showNotification("Erreur", message, "danger", durationMs);
};

export const showOnlineNotification = (message: string) => {
  showNotification("Vous êtes connecté à internet !", message, "default");
};

export const showOfflineNotification = (message: string) => {
  showNotification("Vous n'êtes pas connecté à internet !", message, "danger");
};

export const showTreatmentNotification = (
  message: string,
  durationMs: number = DEFAULT_NOTIFICATION_DURATION_MS
) => {
  showNotification("", message, "success", durationMs);
};
